import React from 'react'

import {brandPurple} from '../styles/brand-colors'
import metaverseBackground from '../../img/metaverse_bg.svg'
import metaverseDevices from '../../img/metaverse_devices.svg'
import {FadeIn} from './fade-in'
import classes from './device-deploy-section.module.scss'

const DeviceDeploySection = () => (
  <section
    className='dark px-0 pb-0 pt-5'
    style={{
      position: 'relative',
      backgroundImage: `linear-gradient(300deg, #5C0D8F, #582E9E 35%, #563BA4 62%, ${brandPurple})`,
      overflowX: 'hidden',
    }}
  >
    <FadeIn>
      <div className='px-4 px-md-0 pt-3'>
        <div>
          <div className='row justify-content-center text-center'>
            <h2 className='text-white h2-xl px-2'>
              Develop Once.<br className='d-block d-sm-none' /> Deploy Everywhere.
            </h2>
          </div>
        </div>
        <div className='row justify-content-center text-center'>
          <FadeIn
            className='col-12 col-sm-10 max-width'
            translateAmount='20px'
            delay={200}
            transitionDuration={800}
            transitionType='ease-out'
          >
            <p className='text-white text8-lg font8-regular'>
              8th Wall’s unique Metaversal Deployment automatically makes your Web AR content
              available across smartphones, computers and AR and VR headsets.
            </p>
          </FadeIn>
        </div>
      </div>
      <div className='position-relative'>
        <div className={classes.metaverseItemsContainer}>
          <img
            className={classes.metaverseItem}
            src={metaverseDevices}
            alt='Devices for the Metaverse'
            draggable={false}
          />
        </div>
        <div className={classes.metaverseBGContainer}>
          <img
            className={classes.metaverseBG}
            src={metaverseBackground}
            alt='Background for metaverse graphic'
            draggable={false}
          />
        </div>
      </div>
    </FadeIn>
  </section>
)

export default DeviceDeploySection
